<template>
  <div id="app" > 
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      color: "blue"
    };
  },
  components: {},
  computed: {
    username: function () {
      return this.$store.state.userName;
    },
    is_superuser: function () {
      return this.$store.state.superUser;
    }
  },
  methods: {
    gohome() {
      this.$router.push({ path: "/" });
    },
    //axios拦截器
    initInterceptors() {
      let that = this;
      this.$axios.interceptors.request.use(
        function (config) {
          let token = that.$cookies.get("access");
          if (token) {
            let Authorization = "Bearer " + token;
            config.headers.common["Authorization"] = Authorization;
          }
          return config;
        },
        function (error) {
          console.log("error:获取本地token 失败 ");
          that.$router.push({ path: "/login" });
          return Promise.reject(error);
        }
      );
    },
    login() {
      this.$router.push({ path: "/login" });
    },
    reg() {
      this.$router.push({ path: "/register" });
    },  
  },
  mounted() {
    this.initInterceptors();
    let username = this.$cookies.get("username"); 
    this.$store.commit("setUserName", username);  
  }
};
</script>

<style lang="less">
#app {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ol-scale-bar {
  bottom: 90px !important;
  left: 70px !important;
}

.ol-scale-text,
.ol-scale-step-text {
  text-shadow: none !important;
  // color:#fff !important;
}
</style>
